/* Défi Sweatix · Slalom — habillage, rendu et dialogue avec le classement.
   La MÉCANIQUE du jeu n'est pas ici : elle vit dans jeu-slalom-sim.js, qui est
   le même fichier que celui tournant sur le serveur. Ici on ne fait que
   dessiner, écouter le doigt, et transmettre la partie. */

function demarrerJeu(root){
  if(!root || root.dataset.slBooted) return;
  root.dataset.slBooted = '1';

  /* Le classement vit HORS de l'arène (on doit pouvoir le lire sans jouer),
     donc on cherche d'abord dans l'arène puis dans toute la section. */
  var section = root.closest('.slalom') || root.parentNode || document;
  var $ = function(s){ return root.querySelector(s) || section.querySelector(s); };
  var cv = $('[data-sl-canvas]'), ctx = cv.getContext('2d');
  var API = (root.dataset.api || '').replace(/\/+$/, '');

  var PALIERS = [];
  try { PALIERS = JSON.parse(root.dataset.paliers || '[]'); } catch(e){ PALIERS = []; }
  PALIERS = PALIERS.filter(function(p){ return p && p.n > 0; })
                   .sort(function(a,b){ return a.n - b.n; });

  var BEST_KEY = 'sweatix_slalom_best', ID_KEY = 'sweatix_slalom_joueur';
  var best = 0;
  try { best = parseInt(localStorage.getItem(BEST_KEY) || '0', 10) || 0; } catch(e){}

  /* ---------- perspective (purement visuel) ---------- */
  var HOR_R = 0.30, CAM = 3.4, HALF_R = 0.47;
  var W = 0, H = 0, HOR = 0, CX = 0, HALF = 0, DPR = 1, cielCache = null;

  function ech(z){ return 1 / (1 + Math.max(z, 0) / CAM); }
  function projY(s){ return HOR + (H - HOR) * s; }
  function projX(wx, s){ return CX + wx * HALF * s; }

  function resize(){
    var r = cv.getBoundingClientRect();
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    W = Math.max(1, Math.round(r.width));
    H = Math.max(1, Math.round(r.height));
    cv.width = W * DPR; cv.height = H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    HOR = H * HOR_R; CX = W / 2; HALF = W * HALF_R;
    cielCache = null;
  }
  if(window.ResizeObserver){ new ResizeObserver(resize).observe(cv); }
  window.addEventListener('resize', resize);

  /* ---------- son ---------- */
  var actx = null, muted = false;
  function beep(freq, dur, type, vol){
    if(muted) return;
    try{
      if(!actx) actx = new (window.AudioContext || window.webkitAudioContext)();
      var o = actx.createOscillator(), g = actx.createGain();
      o.type = type || 'square'; o.frequency.value = freq;
      g.gain.value = (vol == null ? 0.05 : vol);
      g.gain.exponentialRampToValueAtTime(0.0001, actx.currentTime + dur);
      o.connect(g); g.connect(actx.destination);
      o.start(); o.stop(actx.currentTime + dur);
    }catch(e){}
  }
  $('[data-sl-mute]').addEventListener('click', function(){
    muted = !muted; this.textContent = muted ? '🔇' : '🔊';
  });

  /* ---------- état ---------- */
  var S = null;        /* état de simulation, partagé avec le serveur */
  var V = null;        /* état visuel : rien de tout ça n'entre dans le score */
  var hasard = null, graine = 0, tick = 0, accum = 0;
  var entrees = [], derniereCible = null, enCours = false;

  function nouvellePartie(){
    graine = crypto.getRandomValues(new Uint32Array(1))[0] >>> 0;
    hasard = creerHasard(graine);
    S = etatInitial();
    V = { t: 0, bounce: 0, lean: 0, shake: 0, cible: 0, flottants: [], banniere: 0 };
    tick = 0; accum = 0; entrees = []; derniereCible = null;
  }

  function flottant(txt, wx, couleur){
    V.flottants.push({ txt: txt, wx: wx, z: PZ, vie: 1, couleur: couleur || '#C6FF00' });
  }
  function banniere(txt){
    var el = $('[data-sl-banner]');
    el.textContent = txt; el.classList.add('is-on'); V.banniere = 1.4;
  }

  /* ---------- HUD ---------- */
  function majVies(){
    var el = $('[data-sl-lives]'), html = '';
    for(var i = 0; i < 3; i++) html += '<i class="' + (i < S.vies ? '' : 'is-lost') + '"></i>';
    el.innerHTML = html;
  }
  function majHud(){
    var sc = Math.floor(S.score);
    $('[data-sl-score]').textContent = sc;
    $('[data-sl-dist]').textContent = Math.floor(S.dist);
    $('[data-sl-combo]').textContent = '×' + S.combo;
    $('[data-sl-level]').textContent = S.niveau;
    $('[data-sl-best]').textContent = best;

    var suiv = null, prec = 0;
    for(var i = 0; i < PALIERS.length; i++){ if(sc < PALIERS[i].n){ suiv = PALIERS[i]; break; } }
    for(var j = 0; j < PALIERS.length; j++){ if(PALIERS[j].n <= sc) prec = PALIERS[j].n; }
    if(suiv){
      var p = (sc - prec) / Math.max(1, suiv.n - prec);
      $('[data-sl-fill]').style.width = Math.max(0, Math.min(1, p)) * 100 + '%';
      $('[data-sl-next]').innerHTML = '<b>' + suiv.n + '</b> → ' + (suiv.short || '');
    } else {
      $('[data-sl-fill]').style.width = '100%';
      $('[data-sl-next]').textContent = PALIERS.length ? 'Tout débloqué' : '';
    }
  }

  /* ---------- commandes ---------- */
  var gauche = false, droite = false;
  function pointeur(ev){
    if(!enCours) return;
    var r = cv.getBoundingClientRect();
    var cx = (ev.touches ? ev.touches[0].clientX : ev.clientX) - r.left;
    V.cible = Math.max(-0.86, Math.min(0.86, (cx - r.width / 2) / (r.width * HALF_R)));
  }
  cv.addEventListener('pointerdown', pointeur);
  cv.addEventListener('pointermove', function(e){ if(e.buttons || e.pointerType !== 'mouse') pointeur(e); });
  cv.addEventListener('touchmove', function(e){ e.preventDefault(); pointeur(e); }, { passive: false });
  window.addEventListener('keydown', function(e){
    if(e.key === 'ArrowLeft') gauche = true;
    if(e.key === 'ArrowRight') droite = true;
    if(e.key === ' ' && !enCours && !$('[data-sl-ov-start]').classList.contains('sl-ov--hide')){
      e.preventDefault(); demarrer();
    }
  });
  window.addEventListener('keyup', function(e){
    if(e.key === 'ArrowLeft') gauche = false;
    if(e.key === 'ArrowRight') droite = false;
  });

  /* ---------- dessin ---------- */
  function construireCiel(){
    var c = document.createElement('canvas');
    var h = Math.max(1, Math.ceil(HOR));
    c.width = Math.max(1, Math.round(W * DPR)); c.height = Math.ceil(h * DPR);
    var k = c.getContext('2d');
    k.setTransform(DPR, 0, 0, DPR, 0, 0);
    var g = k.createLinearGradient(0, 0, 0, h);
    g.addColorStop(0, '#04060A'); g.addColorStop(0.55, '#0A1620'); g.addColorStop(1, '#0E2A24');
    k.fillStyle = g; k.fillRect(0, 0, W, h);
    k.globalCompositeOperation = 'lighter';
    [[0.16, 0.40], [0.5, 0.26], [0.84, 0.44]].forEach(function(p){
      var x = W * p[0], y = h * p[1], r = h * (0.85 + p[1]);
      var halo = k.createRadialGradient(x, y, 0, x, y, r);
      halo.addColorStop(0, 'rgba(198,255,0,.09)');
      halo.addColorStop(0.5, 'rgba(120,200,255,.035)');
      halo.addColorStop(1, 'rgba(198,255,0,0)');
      k.fillStyle = halo; k.beginPath(); k.arc(x, y, r, 0, Math.PI * 2); k.fill();
    });
    k.globalCompositeOperation = 'source-over';
    var band = k.createLinearGradient(0, h * 0.62, 0, h);
    band.addColorStop(0, 'rgba(198,255,0,0)');
    band.addColorStop(1, 'rgba(198,255,0,.20)');
    k.fillStyle = band; k.fillRect(0, h * 0.62, W, h * 0.38);
    return c;
  }

  function fondEtTerrain(){
    if(!cielCache) cielCache = construireCiel();
    ctx.drawImage(cielCache, 0, 0, W, HOR);
    ctx.fillStyle = '#0C2417'; ctx.fillRect(0, HOR, W, H - HOR);

    var STRIPE = 2.2, n0 = Math.floor(S.dist / STRIPE);
    for(var n = n0; n < n0 + ZFAR / STRIPE + 2; n++){
      var z0 = n * STRIPE - S.dist, z1 = z0 + STRIPE;
      if(z1 <= 0) continue;
      var s0 = ech(Math.max(z0, 0)), s1 = ech(z1);
      var y0 = projY(s0), y1 = projY(s1);
      ctx.fillStyle = (n % 2 === 0) ? '#1A5232' : '#133C24';
      ctx.beginPath();
      ctx.moveTo(CX - HALF * s0, y0); ctx.lineTo(CX + HALF * s0, y0);
      ctx.lineTo(CX + HALF * s1, y1); ctx.lineTo(CX - HALF * s1, y1);
      ctx.closePath(); ctx.fill();
    }

    var DASH = 1.6, d0 = Math.floor(S.dist / DASH);
    ctx.fillStyle = 'rgba(198,255,0,.16)';
    for(var m = d0; m < d0 + ZFAR / DASH + 2; m++){
      var dz0 = m * DASH - S.dist, dz1 = dz0 + DASH * 0.42;
      if(dz1 <= 0) continue;
      var q0 = ech(Math.max(dz0, 0)), q1 = ech(dz1);
      var w0 = Math.max(0.5, W * 0.011 * q0), w1 = Math.max(0.35, W * 0.011 * q1);
      ctx.beginPath();
      ctx.moveTo(CX - w0, projY(q0)); ctx.lineTo(CX + w0, projY(q0));
      ctx.lineTo(CX + w1, projY(q1)); ctx.lineTo(CX - w1, projY(q1));
      ctx.closePath(); ctx.fill();
    }

    var sN = ech(0), sF = ech(ZFAR);
    ctx.save(); ctx.lineCap = 'round';
    [[11, 'rgba(198,255,0,.08)'], [4.5, 'rgba(198,255,0,.28)'], [1.6, 'rgba(230,255,160,.92)']]
      .forEach(function(passe){
        ctx.lineWidth = passe[0]; ctx.strokeStyle = passe[1];
        [-1, 1].forEach(function(cote){
          ctx.beginPath();
          ctx.moveTo(CX + cote * HALF * sN, projY(sN));
          ctx.lineTo(CX + cote * HALF * sF, projY(sF));
          ctx.stroke();
        });
      });
    ctx.restore();
  }

  function brume(){
    var hb = (H - HOR) * 0.40;
    var b = ctx.createLinearGradient(0, HOR, 0, HOR + hb);
    b.addColorStop(0, 'rgba(14,42,36,.80)');
    b.addColorStop(0.40, 'rgba(14,42,36,.30)');
    b.addColorStop(1, 'rgba(14,42,36,0)');
    ctx.fillStyle = b; ctx.fillRect(0, HOR, W, hb);
  }
  function vignette(){
    var v = ctx.createRadialGradient(CX, H * 0.60, H * 0.46, CX, H * 0.60, H * 0.95);
    v.addColorStop(0, 'rgba(0,0,0,0)'); v.addColorStop(1, 'rgba(0,0,0,.24)');
    ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
  }
  function ombre(x, y, r){
    ctx.fillStyle = 'rgba(0,0,0,.34)';
    ctx.beginPath(); ctx.ellipse(x, y, r, r * 0.35, 0, 0, Math.PI * 2); ctx.fill();
  }

  function dessinerCone(wx, z){
    var s = ech(z), x = projX(wx, s), y = projY(s);
    var hh = 0.17 * H * s, bw = hh * 0.46;
    ombre(x, y, bw * 1.15);
    ctx.fillStyle = '#FF6B1A';
    ctx.beginPath(); ctx.moveTo(x, y - hh); ctx.lineTo(x + bw, y); ctx.lineTo(x - bw, y);
    ctx.closePath(); ctx.fill();
    ctx.fillStyle = 'rgba(247,246,242,.88)';
    ctx.fillRect(x - bw * 0.58, y - hh * 0.52, bw * 1.16, Math.max(1, hh * 0.13));
    ctx.fillStyle = '#D2540F';
    ctx.fillRect(x - bw * 1.12, y - Math.max(1, hh * 0.06), bw * 2.24, Math.max(1, hh * 0.06));
  }

  function dessinerPiquet(wx, z){
    var s = ech(z), x = projX(wx, s), y = projY(s);
    var hh = 0.34 * H * s, w = Math.max(1.4, hh * 0.055);
    ombre(x, y, w * 2.2);
    var seg = hh / 6;
    for(var i = 0; i < 6; i++){
      ctx.fillStyle = (i % 2 === 0) ? '#C6FF00' : '#F7F6F2';
      ctx.fillRect(x - w / 2, y - hh + i * seg, w, seg + 0.5);
    }
  }

  function dessinerBallon(){
    var s = ech(PZ), y = projY(s);
    var r = 0.055 * H * s, x = projX(S.px, s);
    var b = Math.abs(Math.sin(V.bounce)) * r * 0.5;
    var cy = y - r - b;

    var op = 0.42 * (1 - b / (r * 1.7));
    ctx.save(); ctx.translate(x, y); ctx.scale(1, 0.32);
    var og = ctx.createRadialGradient(0, 0, 0, 0, 0, r * 1.3);
    og.addColorStop(0, 'rgba(0,0,0,' + op.toFixed(3) + ')');
    og.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = og; ctx.beginPath(); ctx.arc(0, 0, r * 1.3, 0, Math.PI * 2); ctx.fill();
    ctx.restore();

    if(S.inv > 0 && Math.floor(S.inv * 12) % 2 === 0) return;

    if(Math.abs(V.lean) > 0.12){
      for(var k = 1; k <= 3; k++){
        ctx.globalAlpha = 0.09 * (4 - k) / 3;
        ctx.fillStyle = '#C6FF00';
        ctx.beginPath();
        ctx.arc(x - V.lean * r * 0.55 * k, cy, r * (1 - k * 0.13), 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
    }

    ctx.save(); ctx.translate(x, cy);
    var halo = ctx.createRadialGradient(0, 0, r * 0.85, 0, 0, r * 1.8);
    halo.addColorStop(0, 'rgba(198,255,0,.20)'); halo.addColorStop(1, 'rgba(198,255,0,0)');
    ctx.fillStyle = halo; ctx.beginPath(); ctx.arc(0, 0, r * 1.8, 0, Math.PI * 2); ctx.fill();

    var sph = ctx.createRadialGradient(-r * 0.34, -r * 0.40, r * 0.08, 0, 0, r * 1.06);
    sph.addColorStop(0, '#FFFFFF'); sph.addColorStop(0.52, '#ECEDF1');
    sph.addColorStop(0.86, '#BFC3CD'); sph.addColorStop(1, '#8E93A0');
    ctx.fillStyle = sph; ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill();

    ctx.save();
    ctx.beginPath(); ctx.arc(0, 0, r * 0.995, 0, Math.PI * 2); ctx.clip();
    ctx.rotate(V.t * 2.6);
    for(var i = 0; i < 5; i++){
      ctx.save(); ctx.rotate(i * (Math.PI * 2 / 5));
      ctx.fillStyle = (i === 0) ? '#C6FF00' : '#1C2029';
      ctx.beginPath(); ctx.ellipse(0, -r * 0.66, r * 0.27, r * 0.145, 0, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    }
    ctx.fillStyle = '#1C2029';
    ctx.beginPath(); ctx.arc(0, 0, r * 0.13, 0, Math.PI * 2); ctx.fill();
    ctx.restore();

    ctx.strokeStyle = 'rgba(11,11,12,.30)';
    ctx.lineWidth = Math.max(1, r * 0.055);
    ctx.beginPath(); ctx.arc(0, 0, r - ctx.lineWidth / 2, 0, Math.PI * 2); ctx.stroke();

    var refl = ctx.createRadialGradient(-r * 0.33, -r * 0.40, 0, -r * 0.33, -r * 0.40, r * 0.42);
    refl.addColorStop(0, 'rgba(255,255,255,.85)'); refl.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = refl;
    ctx.beginPath(); ctx.arc(-r * 0.33, -r * 0.40, r * 0.42, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  }

  function dessinerFlottants(){
    ctx.textAlign = 'center';
    V.flottants.forEach(function(f){
      var s = ech(f.z), x = projX(f.wx, s), y = projY(s) - (1 - f.vie) * 40 - 30;
      ctx.globalAlpha = Math.max(0, f.vie);
      ctx.fillStyle = f.couleur;
      ctx.font = '700 ' + Math.max(11, 13 * s + 5) + 'px system-ui,sans-serif';
      ctx.fillText(f.txt, x, y);
      ctx.globalAlpha = 1;
    });
    ctx.textAlign = 'start';
  }

  function rendre(){
    if(!W || !H) resize();
    ctx.save();
    if(V.shake > 0){
      ctx.translate((Math.random() - 0.5) * V.shake * 18, (Math.random() - 0.5) * V.shake * 12);
    }
    fondEtTerrain();
    S.obstacles.slice().sort(function(a, b){ return b.z - a.z; }).forEach(function(o){
      var z = o.z - S.dist;
      if(z < -0.5 || z > ZFAR) return;
      if(o.t === 'cone') dessinerCone(o.wx, z);
      else if(o.t === 'pole') dessinerPiquet(o.wx, z);
    });
    brume();
    dessinerBallon();
    dessinerFlottants();
    vignette();
    ctx.restore();
  }

  /* ---------- boucle : pas de temps FIXE, sinon le rejeu serveur diverge ---------- */
  var dernier = 0;
  function boucle(ts){
    var dtReel = Math.min(0.25, (ts - dernier) / 1000 || 0);
    dernier = ts;
    V.t += dtReel;
    V.bounce += dtReel * 9;
    if(V.shake > 0) V.shake -= dtReel;
    if(V.banniere > 0){
      V.banniere -= dtReel;
      if(V.banniere <= 0) $('[data-sl-banner]').classList.remove('is-on');
    }
    for(var k = V.flottants.length - 1; k >= 0; k--){
      V.flottants[k].vie -= dtReel * 1.6;
      if(V.flottants[k].vie <= 0) V.flottants.splice(k, 1);
    }

    if(enCours){
      accum += dtReel;
      var garde = 0;
      while(accum >= DT && garde++ < 8){
        if(gauche) V.cible -= DT * 1.9;
        if(droite) V.cible += DT * 1.9;
        V.cible = Math.max(-0.86, Math.min(0.86, V.cible));

        var q = Math.round(V.cible * 1000);
        if(q !== derniereCible){ entrees.push([tick, q]); derniereCible = q; S.pxCible = q / 1000; }

        S.evenements.length = 0;
        var vivant = pas(S, hasard);
        var avant = S.px;
        V.lean += (Math.max(-1, Math.min(1, (S.pxCible - avant) * 6)) - V.lean) * Math.min(1, DT * 8);

        S.evenements.forEach(function(e){
          if(e.e === 'slalom'){ flottant('+' + e.pts, e.wx); beep(520 + S.combo * 60, 0.09, 'triangle', 0.045); }
          else if(e.e === 'choc'){ flottant('AÏE', e.wx, '#FF6B1A'); V.shake = 0.35; majVies(); beep(130, 0.22, 'sawtooth', 0.06); }
          else if(e.e === 'frole'){ flottant('frôlé +10', e.wx, 'rgba(247,246,242,.8)'); }
          else if(e.e === 'niveau'){ banniere('NIVEAU ' + e.n); beep(880, 0.16, 'square', 0.05); }
        });

        tick++; accum -= DT;
        if(!vivant){ finir(); break; }
      }
      if(garde >= 8) accum = 0;   /* onglet en arrière-plan : on ne rattrape pas */
      majHud();
    }

    rendre();
    requestAnimationFrame(boucle);
  }

  /* ---------- cycle ---------- */
  function demarrer(){
    nouvellePartie();
    enCours = true;
    majVies(); majHud();
    $('[data-sl-ov-start]').classList.add('sl-ov--hide');
    $('[data-sl-ov-over]').classList.add('sl-ov--hide');
    beep(660, 0.1, 'triangle', 0.05);
  }

  function finir(){
    enCours = false;
    var sc = Math.floor(S.score);
    if(sc > best){ best = sc; try { localStorage.setItem(BEST_KEY, String(best)); } catch(e){} }

    $('[data-sl-final]').textContent = sc;
    $('[data-sl-final-dist]').textContent = Math.floor(S.dist);
    $('[data-sl-final-gates]').textContent = S.gates;
    $('[data-sl-final-best]').textContent = best;
    $('[data-sl-legende]').textContent = legende(sc);

    var env = $('[data-sl-envoi]');
    if(env) env.className = 'sl-envoi';
    var res = $('[data-sl-resultat]');
    if(res){ res.className = 'sl-resultat'; res.innerHTML = ''; }
    $('[data-sl-ov-over]').classList.remove('sl-ov--hide');
    beep(180, 0.3, 'sawtooth', 0.05);
  }

  function legende(sc){
    return 'J\'ai marqué ' + sc + ' points au Défi Sweatix ⚽ Tu fais mieux ? '
         + 'getsweatix.com/pages/jeu #sweatix #football #maillot #defisweatix';
  }

  /* ---------- classement ---------- */
  function ligneClassement(l, moi){
    return '<li class="sl-rang' + (moi ? ' is-moi' : '') + '">'
      + '<span class="sl-rang__n">' + l.rang + '</span>'
      + '<span class="sl-rang__p">' + echapper(l.pseudo) + '</span>'
      + '<span class="sl-rang__s">' + l.score + '</span></li>';
  }
  function echapper(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function afficherClassement(top, monPseudo){
    var ul = $('[data-sl-top]');
    if(!ul) return;
    if(!top || !top.length){
      ul.innerHTML = '<li class="sl-rang sl-rang--vide">Personne n\'a encore joué ce mois-ci. À toi.</li>';
      return;
    }
    ul.innerHTML = top.map(function(l){ return ligneClassement(l, monPseudo && l.pseudo === monPseudo); }).join('');
  }

  function chargerClassement(){
    if(!API) return;
    fetch(API + '/classement')
      .then(function(r){ return r.json(); })
      .then(function(j){ afficherClassement(j.top); })
      .catch(function(){});
  }

  /* ---------- envoi de la partie ---------- */
  var form = $('[data-sl-form]');
  if(form){
    try {
      var memo = JSON.parse(localStorage.getItem(ID_KEY) || '{}');
      if(memo.pseudo) form.pseudo.value = memo.pseudo;
      if(memo.email) form.email.value = memo.email;
    } catch(e){}

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!API){ return; }
      var bouton = form.querySelector('[data-sl-envoyer]');
      var pseudo = form.pseudo.value.trim(), email = form.email.value.trim();
      if(!form.accord.checked){ message('Il faut accepter le règlement pour entrer au classement.', true); return; }

      bouton.disabled = true; bouton.textContent = 'Envoi…';
      try { localStorage.setItem(ID_KEY, JSON.stringify({ pseudo: pseudo, email: email })); } catch(e){}

      fetch(API + '/partie', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pseudo: pseudo, email: email, graine: graine,
                               entrees: entrees, ticks: tick, score: Math.floor(S.score) })
      })
      .then(function(r){ return r.json().then(function(j){ return { statut: r.status, j: j }; }); })
      .then(function(rep){
        bouton.disabled = false; bouton.textContent = 'Entrer au classement';
        if(rep.statut !== 200){
          message(rep.j && rep.j.erreur ? rep.j.erreur : 'Envoi refusé.', true);
          return;
        }
        $('[data-sl-envoi]').className = 'sl-envoi sl-envoi--hide';
        var r = $('[data-sl-resultat]');
        var ord = rep.j.rang === 1 ? '<sup>er</sup>' : '<sup>e</sup>';
        var html = '<p class="sl-resultat__rang">Tu es <b>' + rep.j.rang + ord + '</b> ce mois-ci'
                 + (rep.j.rang <= 3 ? ' — sur le podium.' : '.') + '</p>';
        var rec = rep.j.recompense;
        if(rec && rec.code){
          html += '<div class="sl-reward is-on"><div class="sl-reward__label">'
               +  (rec.deja ? 'Ton code de ce mois-ci' : 'Code débloqué')
               +  '</div><div class="sl-reward__box"><code>' + echapper(rec.code)
               +  '</code><button type="button" data-sl-copier="' + echapper(rec.code) + '">Copier</button></div></div>';
        } else if(rec && rec.epuise){
          html += '<p class="sl-note">Palier atteint, mais la réserve de codes est vide — écris-nous.</p>';
        }
        r.innerHTML = html;
        r.className = 'sl-resultat is-on';
        afficherClassement(rep.j.top, rep.j.top && pseudo);
      })
      .catch(function(){
        bouton.disabled = false; bouton.textContent = 'Entrer au classement';
        message('Connexion impossible. Réessaie.', true);
      });
    });
  }

  function message(txt, erreur){
    var el = $('[data-sl-message]');
    if(!el) return;
    el.textContent = txt;
    el.className = 'sl-message' + (erreur ? ' is-erreur' : '');
  }

  /* copier : code promo ou légende TikTok */
  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-sl-copier], [data-sl-copier-legende]');
    if(!b) return;
    var txt = b.hasAttribute('data-sl-copier-legende')
      ? legende(Math.floor(S ? S.score : 0)) : b.getAttribute('data-sl-copier');
    var initial = b.textContent;
    navigator.clipboard.writeText(txt).then(function(){
      b.textContent = 'Copié ✓';
      setTimeout(function(){ b.textContent = initial; }, 2000);
    }).catch(function(){ message(txt); });
  });

  /* ---------- démarrage ---------- */
  $('[data-sl-start]').addEventListener('click', demarrer);
  $('[data-sl-replay]').addEventListener('click', demarrer);

  resize();
  nouvellePartie();
  majVies(); majHud();
  chargerClassement();
  requestAnimationFrame(boucle);
}
document.querySelectorAll('[data-slalom]').forEach(demarrerJeu);